import { render, staticRenderFns } from "./ComplaintReport.vue?vue&type=template&id=6ecf6beb&"
import script from "./ComplaintReport.vue?vue&type=script&lang=js&"
export * from "./ComplaintReport.vue?vue&type=script&lang=js&"
import style0 from "./ComplaintReport.vue?vue&type=style&index=0&id=6ecf6beb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports